import React, { useState } from 'react'
import './leaflet-form.scss'
import InputWebinar from '../../atoms/input-webinar/input-webinar'
import useCities from '../../../shared/hooks/useCities'
import Icon from '../../../shared/components/atoms/Icon/Icon'
import Loader from 'react-loader-spinner'
import WebinarService from '../../../shared/services/webinar'
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode'
import useDocument from '../../../shared/hooks/useDocument';

const LeafletForm = props => {
    const {
        // onSuccessLeafletFrom, isLoading,
        // phone, setphone, errorphone, setErrorphone
        // errorphoneProspect
        setstepState, identificadorWebinar, isPY, pyInfo, profesiones, isWomenWebinar
    } = props;
    const genderOptions = [
        {
            value: 'Femenino',
            label: 'Femenino'
        },
        {
            value: 'Masculino',
            label: 'Masculino'
        },
        {
            value: 'Prefiero no responder',
            label: 'Prefiero no responder'
        },
    ]
    const citiesInfo = useCities();
    const { homeLink } = useHomeLinkMode()
    const documentInfo = useDocument();

    const EMAIL_RX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

    const [isLoading, setisLoading] = useState(false)

    const [name, setname] = useState('')
    const [lastName, setlastName] = useState('')
    const [email, setemail] = useState('')
    const [profession, setprofession] = useState('')
    const [country, setcountry] = useState('')
    const [citiesOptions, setcitiesOptions] = useState([])
    const [countryState, setcountryState] = useState('')
    const [city, setcity] = useState('')
    const [genero, setgenero] = useState('')
    const [dataAccept, setdataAccept] = useState(false)
    const [dataTyc, setdataTyc] = useState(false)
    const [phone, setphone] = useState('')
    const [document, setDocument] = useState('')
    const [documentType, setDocumentType] = useState('')

    const [errorname, setErrorname] = useState(false)
    const [errorlastName, setErrorlastName] = useState(false)
    const [erroremail, setErroremail] = useState(false)
    const [errorprofession, setErrorprofession] = useState(false)
    const [errorgenero, setErrorgenero] = useState(false)
    const [errordataAccept, setErrordataAccept] = useState(false)
    const [errordataTyc, setErrordataTyc] = useState(false)
    const [errorphone, setErrorphone] = useState(false)
    const [countryStateError, setcountryStateError] = useState(false)
    const [cityError, setcityError] = useState(false)
    const [errorDocument, setErrorDocument] = useState(false)
    const [errorDocumentType, setErrorDocumentType] = useState(false)

    const mockOptions = profesiones.map(e => ({ value: e, label: e }))

    const cityLabel = citiesInfo.nombreCiudad;
    const countryStateLabel = citiesInfo.nombreDepartamento;
    const countryStateOptions = citiesInfo.departamentos.map(e => ({ value: e.codigo, label: e.nombre }));

    React.useEffect(() => {
        setcountry(isPY ? 'PARAGUAY' : process.env.COUNTRY_NAME)

        //PR no stateCountry
        if (process.env.LOCALE !== 'es-PR') {
            setcitiesOptions(citiesInfo.departamentos.map(m => ({ value: m.codigo, label: m.nombre })))
        }
    }, [])

    const handleChangeCountryState = value => {
        setcountryState(value)
        if (process.env.LOCALE !== 'es-PR') {
            setcitiesOptions(
                citiesInfo.ciudades.filter(e => e.codigoDepartamento === value).map(m => ({ value: m.codigo, label: m.nombre }))
            )
        }
    }

    const handleOnSubmit = (e) => {
        e.preventDefault()

        if (!haveErrors()) {
            setisLoading(true)
            // onSuccessLeafletFrom({
            //     name, lastName,
            //     phone, email,
            //     profession, dataAccept,
            //     dataTyc
            // })
            let payload = {
                cellPhone: isPY ? pyInfo.COUNTRY_PHONE_PREFIX + phone : process.env.COUNTRY_PHONE_PREFIX + phone,
                countryRegisterId: isPY ? pyInfo.COUNTRY_CODE : process.env.COUNTRY_CODE,
                email: email,
                lastName: lastName,
                name: name,
                tycAccepted: 1,
                // userId: 0,
                uytdAccepted: 1,
                typeId: documentType,
                numberId: document,
            }
            if(isWomenWebinar){
                payload.gender = genero;
                // payload.city = Number(city);
            }
            else{
                payload.profession = profession;
            }
            WebinarService.postRegisterProspect(identificadorWebinar, payload).then(res => {
                setisLoading(false)
                if (res.status === 200) {
                    try {
                        window.dataLayer.push({
                          'event': 'registroWebinar',
                          'value': "exitoso"
                        });
                      } catch (e) {
                        console.log('dataLayer Error', e);
                      }
                    setstepState('step2')
                    setErrorphone(false)
                } else if (res.status === 400 && res.errorCode === "DEM050") {
                    setErrorDocument("El documento ya esta registrado")
                } else if (res.status === 400 && res.errorCode === "DEM011") {
                    setErrorphone('Este celular ya se encuentra registrado con otro correo electrónico.')
                } else if (res.status === 400) {
                    setErroremail(res.userMessage)
                } else {
                    console.log(res);
                }
            })
        }
    }

    const haveErrors = () => {
        if (!name || name === ' ') {
            setErrorname('Debes llenar este campo')
        } else {
            setErrorname(false)
        }

        if (!lastName || lastName === ' ') {
            setErrorlastName('Debes llenar este campo')
        } else {
            setErrorlastName(false)
        }

        if (!documentType || documentType === ' ') {
            setErrorDocumentType('Debes seleccionar una opción')
        } else {
            setErrorDocumentType(false)
        }

        if (!document || document === ' ') {
            setErrorDocument('Debes llenar este campo')
        } else if(document.length < 5 || document.length > 15){
            setErrorDocument('Documento inválido')
        } else {
            setErrorDocument(false)
        }

        if (!phone) {
            setErrorphone('Debes llenar este campo')
        } else {
            if (!phone.match(/^[0-9]*$/i) || phone.length !== parseInt(process.env.CELL_DIG)) {
                setErrorphone('Número inválido')
            } else {
                setErrorphone(false)
            }
        }

        if (!email) {
            setErroremail('Debes llenar este campo')
        } else {
            if (!email.match(EMAIL_RX)) {
                setErroremail('El correo no es válido')
            } else {
                setErroremail(false)
            }
        }

        if (!profession) {
            setErrorprofession('Debes llenar este campo')
        } else {
            setErrorprofession(false)
        }

        if (!dataAccept) {
            setErrordataAccept(true)
        } else {
            setErrordataAccept(false)
        }

        if (!dataTyc) {
            setErrordataTyc(true)
        } else {
            setErrordataTyc(false)
        }

        if(isWomenWebinar){

            if (!genero) {
                setErrorgenero('Debes llenar este campo')
            } else {
                setErrorgenero(false)
            }

            // if (!isPY) {
            //     if (!countryState) {
            //         setcountryStateError('Debes llenar este campo')
            //     } else {
            //         setcountryStateError(false)
            //     }
    
            //     if (process.env.LOCALE !== 'es-PR') {
            //         if (!city) {
            //             setcityError('Debes llenar este campo')
            //         } else {
            //             setcityError(false)
            //         }
            //     }
            // }
        }

        return (
            (!name || name === ' ') ||
            (!document|| document === ' ') ||
            (!documentType|| documentType === ' ') ||
            (!lastName || lastName === ' ') ||
            (!phone ? true : (!phone.match(/^[0-9]*$/i) || phone.length !== parseInt(process.env.CELL_DIG))) ||
            (!email ? true : (!email.match(EMAIL_RX))) ||
            (!dataAccept) || (!dataTyc) ||
            (isWomenWebinar ? 
                (!genero) 
                // || (isPY || process.env.LOCALE === 'es-PR' ? false : !city) || (isPY ? false : (!countryState)) 
                : (!profession)
            )
        )
    }

    const changeDocumentTypeProperties = array =>{
        return array.map( item =>({ label: item.name , value : item.value }));
    }

    return (
        <form className="f-leaflet-form" onSubmit={handleOnSubmit}>
            <div className="f-form-row-group">

                <InputWebinar
                    label='Nombre'
                    placeholder='Ej: Diana'
                    error={errorname}
                    onChange={e => setname(e.replace(/ {2}/g, ' '))}
                    value={name}
                    isWomenWebinar={isWomenWebinar}
                />
                <span />
                <InputWebinar
                    label='Apellido'
                    placeholder='Ej: Ramirez'
                    error={errorlastName}
                    onChange={e => setlastName(e.replace(/ {2}/g, ' '))}
                    value={lastName}
                    isWomenWebinar={isWomenWebinar}
                />
            </div>
            <div className="f-form-row-group">
                <InputWebinar
                    label={documentInfo.inputTipoDeDocumento}
                    placeholder='Selecciona una opción'
                    type='select'
                    options={changeDocumentTypeProperties(documentInfo.tipoDeDocumento)}
                    error={errorDocumentType}
                    onChange={setDocumentType}
                    value={documentType ? documentType : ''}
                    isWomenWebinar={isWomenWebinar}
                />
                <span />
                <InputWebinar
                    label={documentInfo.inputNumeroDeDocumento}
                    placeholder='1193441000'
                    error={errorDocument}
                    onChange={e => setDocument(e.replace(/ {2}/g, ' '))}
                    value={document}
                    isWomenWebinar={isWomenWebinar}
                />
            </div>
            <InputWebinar
                label='Celular'
                placeholder={'Ej: ' + '3003984754'.slice(0, process.env.CELL_DIG)}
                error={errorphone}
                onChange={e => setphone(e.replace(/\D/g, '').slice(0, process.env.CELL_DIG))}
                value={phone}
                isWomenWebinar={isWomenWebinar}
            />
            <InputWebinar
                label='Email'
                placeholder='ejemplo@mail.com'
                error={erroremail}
                onChange={e => setemail(e.replace(/ /g, ''))}
                value={email}
                isWomenWebinar={isWomenWebinar}
            />
            {
            isWomenWebinar ?
            <>
            <InputWebinar
                label='Género'
                placeholder='Selecciona una opción'
                type='select'
                options={genderOptions}
                error={errorgenero}
                onChange={setgenero}
                value={genero}
                isWomenWebinar={isWomenWebinar}
            />
            {/* <div className="f-form-row-group">

                <InputWebinar
                    label='Pais'
                    value={country}
                    disabled={true}
                    isWomenWebinar={isWomenWebinar}
                />
                {!isPY &&
                    <>
                        <span />
                        <InputWebinar
                            label={countryStateLabel}
                            placeholder={countryStateLabel}
                            type='select'
                            options={countryStateOptions}
                            error={countryStateError}
                            onChange={handleChangeCountryState}
                            value={countryState}
                            isWomenWebinar={isWomenWebinar}
                        />
                    </>
                }
                </div> */}

                {/* <div className="f-form-row-group">

                {!isPY && process.env.LOCALE !== 'es-PR' &&
                    <>
                        <InputWebinar
                            label={cityLabel}
                            placeholder={cityLabel}
                            type='select'
                            options={citiesOptions}
                            error={cityError}
                            onChange={setcity}
                            value={city}
                            isWomenWebinar={isWomenWebinar}
                        />
                        <span />
                    </>
                }
                </div> */}
            </>
            :
            <InputWebinar
                label='Ocupación o Profesión'
                placeholder='Selecciona una opción'
                type='select'
                options={mockOptions}
                error={errorprofession}
                onChange={setprofession}
                value={profession}
                isWomenWebinar={isWomenWebinar}

            />
            }
            <br />
            <div className="f-check-group">
                <div className={"f-check-box " + (dataAccept ? 'selected ' : '') + (errordataAccept ? 'error ' : '')} onClick={() => setdataAccept(!dataAccept)}><Icon icon="icon-check" size="0-6" tagtype="i" /></div>
                <a className={ isWomenWebinar ? "f-check-href f-check-href--women" : "f-check-href"} href={homeLink + 'politica-de-privacidad/'} rel="noopener noreferrer" target="_blank">
                    Acepto política de uso de datos
                </a>
            </div>
            <div className="f-check-group">
                <div className={"f-check-box " + (dataTyc ? 'selected ' : '') + (errordataTyc ? 'error ' : '')} onClick={() => setdataTyc(!dataTyc)}><Icon icon="icon-check" size="0-6" tagtype="i" /></div>
                <a className={ isWomenWebinar ? "f-check-href f-check-href--women" : "f-check-href"} href={homeLink + 'terminos-y-condiciones/'} rel="noopener noreferrer" target="_blank">
                    Acepto términos y condiciones
                </a>
            </div>

            {!isLoading ?
                <button className={isWomenWebinar ? "f-leaflet-form-submit f-leaflet-form-submit--women" :"f-leaflet-form-submit"} type="submit">
                    ENVIAR
                </button>
                :
                <div className="f-loader-container">
                    <Loader
                        type="Oval"
                        color="#003784"
                        height={50}
                        width={50}
                    />
                </div>
            }

            <a className="f-enter-webinar" href={homeLink + 'webinar/ingresar/'}>Ingresa al Webinar</a>
        </form>
    )
}

export default LeafletForm
